import { FormattedMessage, defineMessages } from 'react-intl';

import { OwnerTransfer } from '@sorare/core/src/__generated__/globalTypes';
import {
  fantasy,
  glossary,
  transferMarket,
} from '@sorare/core/src/lib/glossary';

const messages = defineMessages({
  crafted: {
    id: 'transfers.shards.title',
    defaultMessage: 'Crafted',
  },
  pack: {
    id: 'transfers.pack.title',
    defaultMessage: 'Pack',
  },
  transfer: {
    id: 'TokenTransferTypeLabel.transfer',
    defaultMessage: 'Transfer',
  },
});

type Props = {
  transferType: OwnerTransfer;
};

export const TokenTransferTypeLabel = ({ transferType }: Props) => {
  switch (transferType) {
    case OwnerTransfer.REFERRAL:
      return <FormattedMessage {...fantasy.referralReward} />;
    case OwnerTransfer.REWARD:
      return <FormattedMessage {...glossary.reward} />;
    case OwnerTransfer.SHARDS:
      return <FormattedMessage {...messages.crafted} />;
    case OwnerTransfer.PACK:
    case OwnerTransfer.BUNDLED_ENGLISH_AUCTION:
      return <FormattedMessage {...messages.pack} />;
    case OwnerTransfer.ENGLISH_AUCTION:
      return <FormattedMessage {...glossary.auction} />;
    case OwnerTransfer.INSTANT_BUY:
      return <FormattedMessage {...transferMarket.instantBuy} />;
    case OwnerTransfer.SINGLE_BUY_OFFER:
    case OwnerTransfer.SINGLE_SALE_OFFER:
    case OwnerTransfer.DIRECT_OFFER:
      return <FormattedMessage {...glossary.trade} />;
    default:
      return <FormattedMessage {...messages.transfer} />;
  }
};
